import { render, staticRenderFns } from "./options-detail.vue?vue&type=template&id=352fdd03&scoped=true"
import script from "./options-detail.vue?vue&type=script&lang=js"
export * from "./options-detail.vue?vue&type=script&lang=js"
import style0 from "./options-detail.vue?vue&type=style&index=0&id=352fdd03&prod&lang=less&scoped=true"
import style1 from "./options-detail.vue?vue&type=style&index=1&id=352fdd03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352fdd03",
  null
  
)

export default component.exports